// extracted by mini-css-extract-plugin
module.exports = {"center":"Start_center__3HxAv","header":"Start_header__UD5-a"};